export default __webpack_public_path__ + "static/media/grid_red_icon.08bd6df2.svg";